import { render, staticRenderFns } from "./ModalWarehouses.vue?vue&type=template&id=3006b3ae&lang=pug&"
import script from "./ModalWarehouses.vue?vue&type=script&lang=js&"
export * from "./ModalWarehouses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports